"use client";
import React from "react";
import { Button } from "antd";

import { setCookie } from "helpers/cookies";
import { getDeviceUuid } from "helpers/guest";

import {
  getDeviceNameTracker,
  setCompanyViewCookiesTracker,
  viewCompanySourceTracker
} from "components/ReportTracker/util";

import styles from "./Company.pc.module.scss";

const sendViewCompany = async (url, company_id, isMobile) => {
  const device_udid = await getDeviceUuid();
  const params = {
    id: company_id,
    payload: {
      source: viewCompanySourceTracker.jobDetail,
      device: getDeviceNameTracker(isMobile),
      device_udid
    }
  };
  setCompanyViewCookiesTracker(setCookie, params);
  window.location.href = url;
};
export default function ViewJobs({ data, lang, isMobile, isRemote }) {
  return (
    <div
      className={styles.viewJobBtn}
      onClick={() =>
        sendViewCompany("/" + lang + data.company_url + "?tab=" + "jobs", data?.id, isMobile)
      }
    >
      <p>
        <span>{data.company_text}</span>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='17'
          height='16'
          viewBox='0 0 17 16'
          fill='none'
        >
          <path
            d='M5.1665 11.3333L11.8332 4.66663M11.8332 4.66663H5.1665M11.8332 4.66663V11.3333'
            stroke='black'
            strokeWidth='1.33333'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </p>
    </div>
  );
}
